import script from "./AuthenticationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthenticationForm.vue?vue&type=script&setup=true&lang=js"

import "./AuthenticationForm.vue?vue&type=style&index=0&id=dd5da094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd5da094"]])

export default __exports__